export interface TrustedDestinationBlockAssociations {
  accounts: { uuid: string; name: string | null }[];
  domains: { uuid: string; name: string | null }[];
  templates: { uuid: string; name: string | null; appliesToAll?: boolean }[];
  templateDomains: { templateUuid: string; domainUuid: string; templateName?: string | null; domainName?: string | null }[];
  powerPages: { uuid: string; name: string | null; domainUuid?: string | null; domainName?: string | null }[];
}

export interface TrustedDestinationBlock {
  module: 'link' | 'e-link' | 'power_page';
  appliesToAll: boolean;
  associations: TrustedDestinationBlockAssociations;
  meta?: Record<string, unknown>;
}

export interface TrustedDestinationAssociations {
  domains: string[];
  domainsDetailed: { uuid: string; name: string | null }[];
  accounts: string[];
  eLinkPages: string[];
  eLinkPagesDetailed: { uuid: string; name: string | null }[];
  eLinkPageDomains: { eLinkPageUuid: string; domainUuid: string; domainName?: string | null; eLinkPageName?: string | null }[];
  powerPages: string[];
  powerPagesDetailed: { uuid: string; name: string | null; domainUuid?: string | null; domainName?: string | null }[];
}

export interface TrustedDestination {
  uuid: string;
  patternExpression: string;
  regexPattern: string;
  status: 'compiled' | 'pending';
  createdAt: string | null;
  updatedAt: string | null;
  creatorUuid: string | null;
  creatorEmail: string | null;
  blocks: TrustedDestinationBlock[];
  associations: TrustedDestinationAssociations;
}

export interface TrustedDestinationListMeta {
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
}

export interface TrustedDestinationListResponse {
  data: TrustedDestination[];
  meta: TrustedDestinationListMeta;
}

export interface TrustedDestinationPayload {
  patternExpression: string;
  associations: {
    blocks: TrustedDestinationBlock[];
  };
}

export interface DomainOption {
  uuid: string;
  name: string;
}

export interface ELinkTemplateOption {
  uuid: string;
  name: string;
  domains: { uuid: string; name: string }[];
}

export interface PowerPageOption {
  uuid: string;
  name: string;
  domainUuid: string | null;
  domainName: string | null;
}

export interface OptionsListMeta {
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
}

export interface DomainsListResponse {
  data: DomainOption[];
  meta: OptionsListMeta;
}

export interface ELinkTemplatesListResponse {
  data: ELinkTemplateOption[];
  meta: OptionsListMeta;
}

export interface PowerPagesListResponse {
  data: PowerPageOption[];
  meta: OptionsListMeta;
}

export const DEFAULT_TRUSTED_DESTINATIONS_CURRENT_PAGE = 1;
export const DEFAULT_TRUSTED_DESTINATIONS_PER_PAGE = 25;
export const TRUSTED_DESTINATIONS_PAGE_SIZE_OPTIONS = [DEFAULT_TRUSTED_DESTINATIONS_PER_PAGE, 50, 100] as const;

export const MODULE_TYPE_LABELS: Record<string, string> = {
  link: 'Default',
  'e-link': 'E-Link',
  power_page: 'Power Page',
};

export function getModuleTypeLabel(module: string): string {
  return MODULE_TYPE_LABELS[module] ?? module;
}

export function createEmptyBlock(module: 'link' | 'e-link' | 'power_page' = 'link'): TrustedDestinationBlock {
  return {
    module,
    appliesToAll: false,
    associations: {
      accounts: [],
      domains: [],
      templates: [],
      templateDomains: [],
      powerPages: [],
    },
  };
}
